import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import {
  PaymentInclusionExclusionRulesResponseV1,
  PaymentRulesResponseV1,
} from '@arc/unified-payments-frontend/shared-payment';

export const PoiStripeResultIntlPaymentRulesActions = createActionGroup({
  source: 'POI Intl Stripe Result Payment Rules',
  events: {
    'Load Payment Rules Success': props<{ payload: PaymentRulesResponseV1 }>(),
    'Load Payment Rules Error': props<{ payload: HttpErrorResponse }>(),
  },
});
